<img class="center-image" alt="" src="/assets/logo.png" />
<p class="center-text upper-space">U heeft geen toegang</p>
<div class="center-button">
  <button type="button" (click)="logout()" mat-button class="button">
    Log uit
  </button>
</div>
